import { t } from "i18next";

const filterConfig = {
  type: "object",
  properties: {
    search: {
      title: "Búsqueda",
      type: "string",
    },
    start_date: {
      type: "string",
      format: "date",
    },
    end_date: {
      type: "string",
      format: "date",
    },
    order_status: {
      type: "integer",
      default: 2, // Payed
      title: t("status"),
    },
    producer_id: {
      type: ["integer", "null"],
      title: "Producer",
      default: null,
    },
  },
};
const getFiltersConfig: any = (type: string) => {
  return filterConfig;
};
export default getFiltersConfig;
